module.exports = __webpack_public_path__ + "img/placeholder (1).ac78921f.svg";